/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * StickyConnection service
 */

namespace Application.Services {
    'use strict';

    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Application.Models.IHalElement;
    import StickyConnection = Application.Models.StickyConnection;
    import IStickyConnection = Application.Models.IStickyConnection;
    import PresetPathBlock = Application.Models.PresetPathBlock;


    /**
     * PresetPathService
     */
    export class PresetPathService {

        public static $name: string = "presetPathService";
        public static $inject: string[] = ['backendService'];

        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'stickyConnections';
        private stickyConnections: string = this.backendUrl + "/allPresetPaths"
        private createUrl: string = this.backendUrl + '/create';
        private createMultiple: string = this.backendUrl + '/create-multiple';


        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }

        public getAllStickyConnections(): ng.IPromise<IStickyConnection[]> {
            return this.backendService.get(this.stickyConnections).then(
                (result: ng.IHttpPromiseCallbackArg<IStickyConnection[]>) => {
                    let stickyConnections: StickyConnection[] = result.data;
                    return stickyConnections;
                });
        }

        public getStickyConnectionsByBlockId(blockId: number): ng.IPromise<IStickyConnection[]> {
            let url = `${this.backendUrl}/byBlockId?blockId=${blockId}`;
            return this.backendService.get(url).then(
                (result: ng.IHttpPromiseCallbackArg<IStickyConnection[]>) => {
                    let stickyConnections: StickyConnection[] = result.data;
                    return stickyConnections;
                });
        }

        public getFilteredStickyConnections(page: number, size: number, textSearch: string, presetPathType: string):
            ng.IPromise<Models.IPaginatedList<IStickyConnection>> {
            let encodedParams: string = Common.Utils.encodeQueryData({
                page: page,
                size: size,
                text: textSearch,
                presetPathType: presetPathType
            });
            let url: string = this.backendUrl  + "/presetPathsFiltered?" + encodedParams;

            return this.backendService.get(url).then(
                (result: ng.IHttpPromiseCallbackArg<IHalList<IStickyConnection>>) => {
                    let convertedList: Models.IPaginatedList<IStickyConnection>;
                    return HalConverter.convertPaginatedList(result.data, StickyConnection.Empty);
                });
        }

        public createMultiPresetPath(multiplePresetPaths: Models.INewMultiplePresetPaths): ng.IPromise<IStickyConnection[]> {
            return this.backendService.post(this.createMultiple, multiplePresetPaths)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<IStickyConnection[]>>) => {
                    let halList: IHalList<StickyConnection> = result.data;
                    let converted: IStickyConnection[] = HalConverter.convertList(halList, StickyConnection.Empty);
                    return converted;
                });

        }

        public createStickyConnection(newStickyConnection: Models.INewStickyConnection): ng.IPromise<IStickyConnection> {
            return this.backendService.post(this.createUrl, newStickyConnection)
                .then((result: ng.IHttpPromiseCallbackArg<IHalElement<IStickyConnection>>) => {
                    return HalConverter.convertElement(result.data, StickyConnection.Empty);
            });
        }


        public removeStickyConnection(stickyConnection: Models.IStickyConnection): ng.IPromise<boolean> {
            return this.backendService.delete(stickyConnection.href);
        }

        public nodesPresetPath(nodeId: string): ng.IPromise<Models.IPresetPathsNode>{
            let url = `${this.backendUrl}/nodePresetPaths?networkNodeHref=${nodeId}`;
            return this.backendService.get(url)
                .then((result: ng.IHttpPromiseCallbackArg<any>) => {
                    return result.data;
                });
        }
        public getPresetPathBlock(blockId: string): ng.IPromise<string[]>{
            let url = `${this.backendUrl}/blockPresetPaths?blockId=${blockId}`;
            return this.backendService.get(url)
                .then((result: ng.IHttpPromiseCallbackArg<any>) => {
                    return result.data;
                });
        }

        public updatePresetPathPassword(stickyConnectionId: number, password: string, name: string): ng.IPromise<{}>{
            let url = `${this.backendUrl}/${stickyConnectionId}/password`;
            const data = {
                password: password,
                name: name ? name : null
            }
            return this.backendService.put(url, data);
        }

        /**
         * Returns the available blocks to create a preset path filtered by connection type
         *
         * @param typeOfConnection connection type
         */
        public getPresetPathBlocksByConnection(typeOfConnection: string): ng.IPromise<PresetPathBlock[]> {
            let url: string = this.backendUrl
                .concat("/availableBlocksByConnection?connectionType=")
                .concat(typeOfConnection);
            return this.getPresetPathBlocks(url);
        }

        /**
         * Returns the available blocks to create a preset path filtered by connection type and block types
         * @param typeOfConnection connection type
         * @param blockTypes block types
         */
        public getPresetPathBlocksByConnectionAndBlockTypes(typeOfConnection: string, blockTypes: number[]): ng.IPromise<PresetPathBlock[]> {
            let url: string = this.backendUrl
                .concat("/availableBlocksByConnectionAndBlockTypes?connectionType=")
                .concat(typeOfConnection)
                .concat("&blockTypes=")
                .concat(blockTypes.toString());
            return this.getPresetPathBlocks(url);
        }

        /**
         * Calls the backend to obtain a preset path blocks list
         * @param url backend url
         * @private
         */
        private getPresetPathBlocks(url: string): ng.IPromise<PresetPathBlock[]> {
            return this.backendService.get(url)
                .then((result: ng.IHttpPromiseCallbackArg<PresetPathBlock[]>) => result.data);
        }
    }
}
